export const API_URL = 'https://www.powerlego.com/ApiGateway/';
export const SIDEBYSIDE_API_URL = 'https://bb0xg7o51l.execute-api.us-east-2.amazonaws.com/beta';
export const ACC_KEY = '8cf1d1a724b83bd26c4da06157b88239';